import React from 'react';
import Info from '../components/Info';

function Contact() {
    return <Info />;
}

export default Contact;
